import HybridMediaCollection from "scripts/collections/hybridMediaCollection";
import BaseView from "scripts/views/baseView";
import MediaSalvattoreGridView from "scripts/views/mediaSalvattoreGridView";

import templateContentDetailsPageAlsoFoundInSubPage from "templates/contentDetailsPageAlsoFoundInSubPage.hbs";

class ContentDetailsPageAlsoFoundInSubPageView extends BaseView {
  get template() {
    return templateContentDetailsPageAlsoFoundInSubPage;
  }

  constructor(options) {
    super(options);

    const mediaId = this.model.get("mediaId");
    const collection = new HybridMediaCollection([], {
      path: `/media/${mediaId}/found-in`,
    });


    this.mediaSalvattoreView = this.addSubView(
      new MediaSalvattoreGridView({
        collection: collection,
      }),
    );
  }

  render() {
    this.$el.html(this.template());

    this.mediaSalvattoreView
      .appendTo(this.$el.find("#bb-content-details-also-found-in-media-region"))
      .render();

    return this;
  }

  sync() {
    return this.mediaSalvattoreView.fetch();
  }
}

export default ContentDetailsPageAlsoFoundInSubPageView;
